import React from 'react';
import { Route, Routes } from 'react-router-dom';


import Homepage from './components/frontend/Homepage';
import FooterHome from './components/frontend/FooterHome';
import HeaderHome from './components/frontend/HeaderHome';
import Overview from './components/frontend/Overview';
import SeniorCare from './components/frontend/SeniorCare';
import ChildWelfare from './components/frontend/ChildWelfare';
import DisabilitySupport from './components/frontend/DisabilitySupport';
import HealthMedical from './components/frontend/HealthMedical';
import EducationForPoor from './components/frontend/EducationForPoor';
import EnvironmentConservation from './components/frontend/EnvironmentConservation';
import CommunityService from './components/frontend/CommunityService';
import DonorBenefits from './components/frontend/DonorBenefits';
import TirupatiDarshanam from './components/frontend/TirupatiDarshanam';
import Contact from './components/frontend/Contact';
import Volunteer from './components/frontend/Volunteer';
import Donate from './components/frontend/Donate';
import Certificates from './components/frontend/Certificates';

import Navigation from './components/admin/Navigation';
import Footer from './components/admin/Footer';
import Profile from './components/admin/Profile';
import ChangePassword from './components/admin/ChangePassword';
import Dashboard from './components/admin/Dashboard';
import Photos from './components/admin/Photos';
import Videos from './components/admin/Videos';
import Contacts from './components/admin/Contacts';
import Donations from './components/admin/Donations';


import './App.css';

import Login from './services/Login';
import PrivateRoute from './services/PrivateRoute';




// ✅ Wrapper for protected layout
const AdminLayout = ({ children }) => (
  <div className="App">
    <Navigation />
    {children}
    <Footer />
  </div>
);

function App() {
  return (
    <Routes>

      {/* Public Routes */}
      <Route path="/" element={<Homepage />} />
      <Route path="/homepage" element={<Homepage />} />
      <Route path="/overview" element={<Overview />} />
      <Route path="/care-for-senior-citizens" element={<SeniorCare />} />
      <Route path="/child-welfare" element={<ChildWelfare />} />
      <Route path="/disability-support" element={<DisabilitySupport />} />
      <Route path="/health-medical" element={<HealthMedical />} />
      <Route path="/education-for-poor" element={<EducationForPoor />} />
      <Route path="/environment-conservation" element={<EnvironmentConservation />} />
      <Route path="/community-service" element={<CommunityService />} />
      <Route path="/donor-benefits" element={<DonorBenefits />} />
      <Route path="/tirupati-darshanam" element={<TirupatiDarshanam />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/volunteer" element={<Volunteer />} />
      <Route path="/donate" element={<Donate />} />
      <Route path="/certificates" element={<Certificates />} />

      <Route path="/login" element={<Login />} />


      <Route
        path="/admin/dashboard"
        element={
          <PrivateRoute>
            <AdminLayout>
              <Dashboard />
            </AdminLayout>
          </PrivateRoute>
        }
      />

      <Route
        path="/admin/photos"
        element={
          <PrivateRoute>
            <AdminLayout>
              <Photos />
            </AdminLayout>
          </PrivateRoute>
        }
      />


      <Route
        path="/admin/videos"
        element={
          <PrivateRoute>
            <AdminLayout>
              <Videos />
            </AdminLayout>
          </PrivateRoute>
        }
      />

      <Route
        path="/admin/contacts"
        element={
          <PrivateRoute>
            <AdminLayout>
              <Contacts />
            </AdminLayout>
          </PrivateRoute>
        }
      />

      <Route
        path="/admin/donations"
        element={
          <PrivateRoute>
            <AdminLayout>
              <Donations />
            </AdminLayout>
          </PrivateRoute>
        }
      />


      <Route
        path="/user/profile"
        element={
          <PrivateRoute>
            <AdminLayout>
              <Profile />
            </AdminLayout>
          </PrivateRoute>
        }
      />

      <Route
        path="/user/change-password"
        element={
          <PrivateRoute>
            <AdminLayout>
              <ChangePassword />
            </AdminLayout>
          </PrivateRoute>
        }
      />

      {/* Protected Routes */}



    </Routes>
  );
}

export default App;